// Shared in-memory cache for installments so the 3 dashboard components
// share a single network request. Components subscribe via useInstallments().
import { useEffect, useState } from "react";
import { listInstallments as apiList } from "@/lib/installmentsApi";

let cache = null;
let inflight = null;
const listeners = new Set();

function notify(data) { listeners.forEach((fn) => fn(data)); }

export async function fetchInstallments(force = false) {
  if (!force && cache) return cache;
  if (!force && inflight) return inflight;
  inflight = apiList().then((data) => { cache = data; inflight = null; notify(data); return data; })
    .catch(() => { inflight = null; return cache || { active: [], completed: [], total_monthly: 0 }; });
  return inflight;
}

export function refreshInstallments() {
  return fetchInstallments(true);
}

export function useInstallments() {
  const [state, setState] = useState(cache);
  useEffect(() => {
    listeners.add(setState);
    if (!cache && !inflight) fetchInstallments();
    return () => listeners.delete(setState);
  }, []);
  return state || { active: [], completed: [], total_monthly: 0 };
}
